<template>
    <div>
        <v-container grid-list-xl fluid>
                <v-layout v-if="data.received" row wrap>
                    <v-flex xs12>
                        <v-widget title="اطلاعات خرید">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex xs6>
                                            <table class="basket-table">
                                                <tbody>
                                                <tr>
                                                    <td>شماره خرید</td>
                                                    <td>{{data.basket.basket_id}}</td>
                                                </tr>
                                                <tr>
                                                    <td>وضعیت پرداخت</td>
                                                    <td>
                                                        <v-chip v-if="data.basket.is_paid === 'Y' && data.basket.is_cleared === 'N' && data.basket.inner_payment_amount === 0"
                                                                text-color="white"
                                                                color="red">پرداخت نشده توسط نماینده
                                                        </v-chip>
                                                        <v-chip v-if="data.basket.is_paid === 'N'" text-color="white"
                                                                color="red">پرداخت نشده
                                                        </v-chip>
                                                        <v-chip v-else text-color="white" color="green">پرداخت شده
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>تاریخ سفارش</td>
                                                    <td>{{toJalali(data.basket.created_at,false)}}</td>
                                                </tr>
                                                <tr>
                                                    <td>مبلغ واریزی</td>
                                                    <td>{{moneyFormat(data.basket.outer_payment_amount)}} ریال</td>
                                                </tr>
                                                <tr>
                                                    <td>مجموع هزینه آیتم‌ها</td>
                                                    <td>{{moneyFormat(data.basket.total)}} ریال</td>
                                                </tr>
                                                <tr>
                                                    <td>هزینه‌های اضافه</td>
                                                    <td>{{moneyFormat(data.basket.additional_costs)}} ریال</td>
                                                </tr>
                                                <tr>
                                                    <td>مجموع تخفیفات</td>
                                                    <td>{{moneyFormat(data.basket.offers_amount)}} ریال</td>
                                                </tr>
                                                <tr>
                                                    <td>هزینه حمل</td>
                                                    <td>{{moneyFormat(data.basket.transportation_cost)}} ریال</td>
                                                </tr>
                                                <tr>
                                                    <td>مجموع هزینه‌ها</td>
                                                    <td>
                                                        <v-chip text-color="white" color="blue">
                                                            {{moneyFormat(data.basket.total +
                                                            data.basket.additional_costs +
                                                            data.basket.transportation_cost -
                                                            data.basket.offers_amount)}} ریال
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </v-flex>
                                        <v-flex xs6>
                                            <table class="basket-table">
                                                <tbody>
                                                <tr>
                                                    <td>نام خریدار</td>
                                                    <td>{{data.basket.receiver_name}}</td>
                                                </tr>
                                                <tr>
                                                    <td>شماره تماس</td>
                                                    <td>
                                                        {{data.basket.mobile}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>نوع ارسال</td>
                                                    <td>{{deliveryType(data.basket.delivery_type)}}</td>
                                                </tr>
                                                <tr>
                                                    <td>کد پستی</td>
                                                    <td>{{data.basket.postal}}</td>
                                                </tr>
                                                <tr>
                                                    <td>آدرس</td>
                                                    <td>{{data.basket.address}}</td>
                                                </tr>
                                                <tr>
                                                    <td>توضیحات خریدار</td>
                                                    <td>{{data.basket.user_description}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            وضعیت سفارش:
                                            <v-chip color="orange" text-color="white">
                                                {{orderStatus(data.basket.order_status)}}
                                                <b v-if="data.basket.order_status === 3">کدپیگیری: {{data.basket.tracking_code}}</b>
                                            </v-chip>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
        </v-container>

        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>لیست محصولات</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">{{props.item.blank_name}}</td>
                                    <td class="text-xs-center">{{props.item.artwork_title}}</td>
                                    <td class="text-xs-center">{{props.item.type_name}}</td>
                                    <td class="text-xs-center">{{props.item.size_name}}</td>
                                    <td class="text-xs-center">{{props.item.color_name}}</td>
                                    <td class="text-xs-center">
                                        <a v-for="side in props.item.sides" v-bind:key="side[1]"
                                           target="_blank"
                                           :href="`/api/reseller/basket_artwork/`+props.item.item_type+`/`+$route.params.id+`/`+props.item.basket_s_id+`/`+side[0]+`.png?Authorization=`+AuthToken()"
                                        >{{side[1]}}</a>
                                    </td>
                                    <td class="text-xs-center">{{props.itemadditionals}}</td>
                                    <td class="text-xs-center">{{moneyFormat(props.item.unit_price)}}</td>
                                    <td class="text-xs-center">{{toPersianDigit(props.item.quantity)}}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>

        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import VWidget from '@/components/VWidget';
import ImageSelect from '@/components/ImageSelect';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  components: {
    VWidget,
    ImageSelect
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        headers: [
          {
            text: 'نوع محصول',
            value: 'blank_name',
            align: 'center'
          },
          {
            text: 'طرح',
            value: 'artwork_title',
            align: 'center'
          },
          {
            text: 'جنس',
            value: 'type_name',
            align: 'center'
          },
          {
            text: 'سایز',
            value: 'size_name',
            align: 'center'
          },
          {
            text: 'رنگ',
            value: 'color_name',
            align: 'center'
          },
          {
            text: 'جهات چاپ',
            value: 'sides',
            align: 'center'
          },
          {
            text: 'خدمات اضافه',
            value: 'additionals',
            align: 'center'
          },
          {
            text: 'قیمت واحد',
            value: 'unit_price',
            align: 'center'
          },
          {
            text: 'تعداد',
            value: 'quantity',
            align: 'center'
          }
        ],
        items: []
      },
      statuses: [
        {
          title: 'معلق/پرداخت نشده',
          id: 0
        },
        {
          title: 'قرار گرفته شده در روند چاپ',
          id: 1
        },
        {
          title: 'برگشت خورده',
          id: 2
        },
        {
          title: '** ارسال شده **',
          id: 3
        },
        {
          title: '...لغو شده',
          id: 4
        },
        {
          title: 'آماده ارسال',
          id: 5
        },
        {
          title: 'در انتظار تایید حسابداری',
          id: 6
        },
        {
          title: 'ارسال شده به کارگاه خیاطی',
          id: 7
        }
      ],
      data: {
        received: false,
        basket: { basket_id: 0 },
      }
    };
  },
  mounted () {

    this.axios.get('/reseller/basket_details/' + this.$route.params.id)
      .then(response => {
        this.data = response.data;
        response.data.basket_items = response.data.basket_items.map(item => {
          item.sides = item.sides.split(',');
          item.sides = item.sides.map(i => {
            i = i.split('|');
            if (i.length < 2) {
              return i;
            }
            if (i[1] === '-') {
              i[1] = '[مشاهده طرح]';
            }
            return i;
          });
          return item;
        });
        this.complex.items = response.data.basket_items;

        if (response.data.basket.basket_id === 0) {
          this.snackbar.snackbar = true;
          this.snackbar.text = 'خریدی با این مشخصات یافت نشد';
          this.snackbar.color = 'red';
        } else {
          this.data.received = true;
        }
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    deliveryType (id) {
      switch (id) {
        case 1:
          return 'پست سفارشی';
        case 2:
          return 'پست پیشتاز';
        case 3:
          return 'پیک موتوری الوپیک';
      }
      return 'تحویل از دفتر چاپچی';
    },
    orderStatus (id) {
      return this.statuses[id].title;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/basket_details/show.vue